module.exports = __webpack_public_path__ + "assets/youtube.7383403f.svg";